import { PropsWithChildren } from 'react';
import { css } from '@emotion/react';

type FormProps = { className?: string } & PropsWithChildren;

export function Form(props: FormProps): JSX.Element {
  return (
    <div
      css={css({
        display: 'flex',
        flexDirection: 'column',
        gap: 24,
        width: '100%',
      })}
      className={props.className}
    >
      {props.children}
    </div>
  );
}
